import apiClient from '@u/apiClient'

let base_errors = {}
export default {
  //region fetch
  async fetchTasksList({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/fetch-task')
      .then(async (response) => {
        commit('setTasksList', response.data.tasks)
        commit('setTaskMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchTasksList', reason)
      })
  },
  async fetchTaskById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/task/${payload.id}`)
      .then(async (response) => {
        commit('setTask', response.data.task)
        commit('setTaskMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchTaskById', reason)
      })
  },
  async fetchNewTask({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/model/new?model=Task')
      .then(async (response) => {
        await commit('setTask', response.data.Task)
        await commit('setTaskMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewTask', reason)
      })
  },
  async fetchTaskActivitiesByTaskID({ commit }, payload) {
    await apiClient
      .get(`api/task/fetch-activities/${payload.task_id}`)
      .then(async (response) => {
        await commit('setTaskActivity', response.data.activities)
      })
      .catch(async (reason) => {
        await console.error('fetchTaskActivitiesByTaskID', reason)
      })
  },
  //endregion

  //region store
  storeTask(_, payload) {
    return apiClient.post('api/task', payload.task).then(async (response) => {
      return response.data
    })
  },
  //endregion

  //region update
  updateTask(_, payload) {
    return apiClient
      .put(`api/task/${payload.id}`, payload.task)
      .then(async (response) => {
        return response.data
      })
  },
  //endregion

  //region delete
  deleteTaskById({ commit }, payload) {
    return apiClient.delete(`api/task/${payload.id}`).then(async (response) => {
      commit('setTasksList', response.data.tasks)
      commit('setTaskMetadata', response.data.metadata)
      return response.data
    })
  },
  //endregion

  //region undoDelete
  undoDeleteTaskById({ commit }, payload) {
    return apiClient
      .get(`api/task/undo-delete/${payload.id}`)
      .then(async (response) => {
        commit('setTasksList', response.data.tasks)
        commit('setTaskMetadata', response.data.metadata)
        return response.data
      })
  }
  //endregion
}
